import { render, staticRenderFns } from "./1_VincularPromocao.vue?vue&type=template&id=25fad5b1&"
import script from "./1_VincularPromocao.vue?vue&type=script&lang=js&"
export * from "./1_VincularPromocao.vue?vue&type=script&lang=js&"
import style0 from "./1_VincularPromocao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports